export default __webpack_public_path__ + "static/media/grassfloor.1a2fbe6e.png";